import {types} from './types';

const setGetPresentListAction = (payload) => {
    return {
        type: types.SET_GET_PRESENT,
        payload,
      }
}


export {
  setGetPresentListAction,
}